import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['refreshBtn'];

  disconnect() {
    this.clearTimeout();
    this.hideRefreshBtn();
  }

  // Only show the button when history modal is open
  showRefreshBtn() {
    if (this.element.hasAttribute('aria-hidden')) return;
    this.refreshBtnTarget.hidden = false;
  }

  hideRefreshBtn() {
    $(this.refreshBtnTarget).tooltip('hide');
    this.refreshBtnTarget.hidden = true;
    this.refreshBtnTarget.disabled = false;
  }

  historyInSync() {
    this.refreshBtnTarget.disabled = true;
    const title = this.refreshBtnTarget.getAttribute('aria-describedby');
    const tooltip = document.getElementById(title);
    if (tooltip) {
      const inner = tooltip.querySelector('.tooltip-inner');
      if (inner) inner.innerText = this.refreshBtnTarget.dataset.refreshedText || 'History refreshed!';
      $(this.refreshBtnTarget).tooltip('update');
    }

    this.clearTimeout();
    this.timeout = setTimeout(this.hideRefreshBtn.bind(this), 1000);
  }

  loadHistory(event) {
    const { target } = event;
    if (!(target instanceof HTMLElement)) return;

    const { id } = target.dataset;
    if (!id) return;

    this.dispatch('load', { detail: { id }, bubbles: true });
  }

  refreshHistory() {
    this.dispatch('refresh', { bubbles: true });
  }

  // Private

  clearTimeout() {
    if (this.timeout) clearTimeout(this.timeout);
  }
}
